export default "__VITE_ASSET__BFyz$P$T__"